import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import style from './FAQLists.module.css';
import HeadSub from '../../../../components/comm/HeadSub';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import Skeleton from '@mui/material/Skeleton';
import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';

const FAQLists = () => {


    const location = useLocation();
    const { hosptCd } = location.state || {};
    
    const hospitCds = hosptCd;

    
    //데이터
    const faqInfoParam = {
        hsptlCd: hospitCds,
        boardCd: "faq",
        keyword: ""
    };

    //FAQ 리스트
    const [faqList, setFaqList] = useState([]);

    //FAQ 카테고리
    const [faqCategory, setFaqCategory] = useState([]);

    //탭
    const [value, setValue] = useState("전체"); 
    const [expanded, setExpanded] = useState(false);

    //로딩
    const [isLoading, setIsLoading] = useState(false);

    const isSendingRef = useRef(false);

    const hospitalinfo = {
        "012": { name: "서울성모병원" },
        "011": { name: "여의도성모병원" },
        "015": { name: "은평성모병원" },
        "013": { name: "의정부성모병원" },
        "014": { name: "부천성모병원" },
        "016": { name: "인천성모병원" },
        "018": { name: "대전성모병원" },
    };

    const hospital = hospitalinfo[hospitCds];

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setExpanded(false); // 탭 상태 초기화
    };

    const acHandleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    //API 호출
    const getFaqInitInfo = useCallback(async () => {
        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);

        const url = "/guide/board/retrieveBoardList";

        try {
           
            const res = await axiosApi.post(url, faqInfoParam);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {

                let faqBundle = res.data.result.faqInfo;
                let faqBundleParsed = [];
                
                //JSON 파싱
                faqBundleParsed = JSON.parse(faqBundle);
                
                setFaqList(faqBundleParsed);

                
                //카테고리 중복 제거 가져오기
                const existingCategories = Array.from(
                    new Set(
                        faqBundleParsed
                            .map(item => (item.category || '').trim())
                            .filter(cat => cat !== '')
                    )
                );
                setFaqCategory(existingCategories);
            
            } 
        } catch (err) {
            console.error(err);
            setFaqList([]);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getFaqInitInfo();
    }, [getFaqInitInfo]);

    // 필터링
    const filteredFaqList = value === "전체" 
        ? faqList 
        : faqList.filter(item => item.category?.trim() === value);
       
    
    return (
        <>
            <HeadSub title="자주 찾는 질문" hospitalName={hospital.name} />

            <div id="sub-content" data-type="d">
                <div className="inner-wrap" data-pad="normal">
                    <div className={style['top-fix-bar']}>
                        <TabContext value={value}>
                            <div className="top-tab-head" data-type="b">
                                <TabList
                                    onChange={handleChange}
                                    aria-label="faq tab"
                                    variant="scrollable"
                                    scrollButtons={false}
                                    className={style['tab-lists']}
                                >
                                    <Tab label="전체" value="전체" disableRipple />

                                    {isLoading ? (
                                        Array.from({ length: 3 }).map((_, index) => (
                                            <Tab key={`skeleton-tab-${index}`} label="" sx={{ width: 80 }} />
                                        ))  
                                    ) : faqCategory.map((catg) => (
                                        <Tab key={`catg-${catg}`} label={catg} value={catg} disableRipple />
                                    ))}
                                </TabList>
                            </div>

                            <TabPanel value={value}>
                                <div className={style['tab-content']}>
                                    {isLoading ? (
                                        <div className="accordion-wrap" data-type="e">
                                            {Array.from({ length: 6 }).map((_, index) => (
                                                <Accordion
                                                    key={`skeleton-panel-${index}`}
                                                    expanded={expanded === `panel${index}`}
                                                    onChange={acHandleChange(`panel${index}`)}
                                                >
                                                    <AccordionSummary>
                                                        <div className="accordion-head">
                                                            <Skeleton variant="text" height={24} width={80}/>
                                                            <p className="tit">
                                                                <Skeleton variant="text" height={24} width={'80%'}/>
                                                            </p>
                                                        </div>   
                                                    </AccordionSummary>
                                                </Accordion>
                                            ))}  
                                        </div> 
                                    ) : (
                                        <div className="accordion-wrap" data-type="e">
                                            {filteredFaqList.map((faq, idx) => (
                                                <Accordion
                                                    key={`faq-${faq.boardSeq}-${idx}`}
                                                    expanded={expanded === `panel${idx}`}
                                                    onChange={acHandleChange(`panel${idx}`)}
                                                >
                                                    <AccordionSummary>
                                                        <div className="accordion-head">
                                                            <span className='category'>{faq.category}</span>
                                                            <p className="tit">
                                                                <b>Q.</b>{faq.title}
                                                            </p>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <div className="accordion-body">
                                                            <div className='infom-box'>
                                                                <p className='tit'><b>A.</b>
                                                                    <span dangerouslySetInnerHTML={{ __html: faq.content
                                                                         .replace(/ style="[^"]*"/gi, '')
                                                                         .replace(/≫/g, '')
                                                                        }} />
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))}
                                            {filteredFaqList.length === 0 && (
                                                <div className={style['no-data-box']}>
                                                    <div className={style['img-box']}>
                                                     <object data={noDataImg} aria-hidden='true'></object>        
                                                    </div>
                                                    <p>FAQ가 없습니다.</p>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </TabPanel>
                        </TabContext>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FAQLists;
